"use client"

import { useState } from "react"
import { Routes, Route, useLocation } from "react-router-dom"
import Sidebar from "../common/Sidebar"
import Header from "../common/Header"
import Dashboard from "./Dashboard"
import Students from "./Students"
import StudentAssignments from "./StudentAssignments"
import Assignments from "./Assignments"
import AssignmentDetails from "./AssignmentDetails"
import Messages from "./Messages"
import "../admin/AdminDashboard.css"
import "./MentorDashboard.css"

const MentorDashboard = ({ user, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const location = useLocation()

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  const menuItems = [
    { path: "/mentor", label: "Dashboard", icon: "dashboard" },
    { path: "/mentor/students", label: "My Students", icon: "people" },
    { path: "/mentor/student-assignments", label: "Student Assignments", icon: "assignment" },
    { path: "/mentor/messages", label: "Messages", icon: "message" },
  ]

  return (
    <div className={`mentor-dashboard ${sidebarOpen ? "sidebar-open" : ""}`}>
      <Sidebar
        menuItems={menuItems}
        isOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        currentPath={location.pathname}
        userRole="mentor"
      />

      <div className="main-content">
        <Header
          title={menuItems.find((item) => item.path === location.pathname)?.label || "Dashboard"}
          user={user}
          onLogout={onLogout}
          toggleSidebar={toggleSidebar}
        />

        <div className="content-container">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/students" element={<Students />} />
            <Route path="/student-assignments" element={<StudentAssignments />} />
            <Route path="/assignments" element={<Assignments />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/assignments/:id" element={<AssignmentDetails />} />
          </Routes>
        </div>
      </div>
    </div>
  )
}

export default MentorDashboard
